module.exports = __webpack_public_path__ + "img/bg.97183ef6.jpeg";